import { EntityModel } from '@/interfaces'
import {
  ALL_ESIM_REGIONS_QUERY,
  CREATE_ESIM_REGION_MUTATION,
  DELETE_ESIM_REGION_MUTATION,
  FORCE_DELETE_ESIM_REGION_MUTATION,
  SINGLE_ESIM_REGION_QUERY,
  UPDATE_ESIM_REGION_MUTATION,
} from './graphql'

const ratioEsimRegionModel: EntityModel = {
  name: 'esimRegion',
  namePlural: 'esimRegions',
  uniqueName: 'ratioEsimRegion',
  uniqueNamePlural: 'ratioEsimRegions',
  path: 'config/ratio/esim/esim_region',
  baseUrl: '/config/ratio/esim/esim_regions',
  translationPrefix: 'entities:ratioEsimRegion.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_ESIM_REGIONS_QUERY,
    getSingle: SINGLE_ESIM_REGION_QUERY,
    create: CREATE_ESIM_REGION_MUTATION,
    update: UPDATE_ESIM_REGION_MUTATION,
    delete: DELETE_ESIM_REGION_MUTATION,
    forceDelete: FORCE_DELETE_ESIM_REGION_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:ratioEsimRegion.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    serviceCodePrefix: {
      name: 'serviceCodePrefix',
      label: 'entities:ratioEsimRegion.attributes.serviceCodePrefix.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default ratioEsimRegionModel
